module.exports = __webpack_public_path__ + "static/img/home-banners-mob21.c1f84a14.jpg";